import script from "./ProductReturns.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductReturns.vue?vue&type=script&setup=true&lang=js"

import "./ProductReturns.vue?vue&type=style&index=0&id=26efd569&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26efd569"]])

export default __exports__